import Image from "../assets/image";

const TalnetbgImageData = [
    {
        id: 1,
        backgroundImage: Image.talentBgImg1,
    },
    {
        id: 2,
        backgroundImage: Image.talentBgImg2,
    },
    {
        id: 3,
        backgroundImage: Image.talentBgImg3,
    },
    {
        id: 4,
        backgroundImage: Image.talentBgImg4,
    },
    {
        id: 5,
        backgroundImage: Image.talentBgImg5,
    },
    {
        id: 6,
        backgroundImage: Image.talentBgImg6,
    },
    {
        id: 7,
        backgroundImage: Image.talentBgImg7,
    },
    {
        id: 8,
        backgroundImage: Image.talentBgImg8,
    },
    {
        id: 9,
        backgroundImage: Image.talentBgImg9,
    },
    {
        id: 10,
        backgroundImage: Image.talentBgImg10,
    },
    {
        id: 11,
        backgroundImage: Image.talentBgImg11,
    },
    {
        id: 12,
        backgroundImage: Image.talentBgImg12,
    },
];
export default TalnetbgImageData
